import axios from 'axios'
import { Address } from './postcode-repository.types'

interface PostcodeRepositoryResult {
  findByContainer: (container: string) => Promise<Record<string, string>[]>
  findByText: (text: string) => Promise<{
    Items: Record<string, string>[]
    Error: string
  }>
  retrieveAddress: (addressId: string) => Promise<Address>
}

const PostcodeRepository = ({
  postcodeBaseURL,
  postcodeFindPath,
  postcodeRetrievePath,
  postcodeKey
}: Record<string, string>): PostcodeRepositoryResult => {
  const client = axios.create({
    baseURL: postcodeBaseURL,
    headers: {
      'x-origin-id': 'app-form'
    }
  })

  const findByContainer = async (container: string) => {
    const result = await client.get(postcodeFindPath,
      {
        params: {
          Key: postcodeKey,
          Method: 'Match',
          Container: container,
          Filter: 'Component',
          Language: 'en-gb',
          Countries: 'GB'
        }
      })

    return result.data.Items.filter((item: Record<string, unknown>) => item.Type === 'Address')
  }

  const findByText = async (text: string) => {
    const result = await client.get(postcodeFindPath,
      {
        params: {
          Key: postcodeKey,
          Text: text,
          Method: 'Match',
          Language: 'en-gb',
          Filter: 'Address',
          Countries: 'GB'
        }
      })
    return result.data
  }

  const retrieveAddress = async (addressId: string) => {
    const result = await client.get(postcodeRetrievePath, {
      params: {
        Key: postcodeKey,
        Id: addressId
      }
    })
    if (result.data.Items.length === 0) {
      return null
    }
    return result.data.Items[0]
  }

  return {
    findByContainer,
    findByText,
    retrieveAddress
  }
}

export default PostcodeRepository
